import Helper from '../../lib/Helper';

export default {

	init() {
		
	},
};